// USA
export const locale = {
  lang: 'ar',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      Keywords: ' الكلمات المفتاحية',
      Next: 'التالي',
      Previous: 'السابق',
      TotalQuranKaremCourseCount: 'عدد حلقات القرآن الكريم',
      HomeWorkAttachment: 'الملفات المرفقة',
      IsVisibleToApply: 'إمكانية التقديم',
      DueDate: '   اخر تاريخ للتقديم',
      ReadMore: ' اقرأ المزيد',
      Zar3: 'زرع',
      FullText: ' النص كامل   ',
      BranchesCount: 'عدد المراكز',
      CoursesCount: 'عدد الحلقات',
      AboutUs: 'حولنا',
      UpdatePassword: 'تحديث كلمة المرور',
      PageName: 'اسم الصفحة',
      TeacherReports: 'تقارير المعلمين',
      StudentReports: 'تقارير الطلاب',
      GeneralReports: 'تقارير التجمع',
      BranchesReports: 'تقارير المراكز',
      CourseReports: 'تقارير الحلقات',
      LevelStageReports: 'تقارير الفئات والمستويات',
      Admin: ' مشرف  ',
      PrivacyPolicy: 'سياسة الخصوصية',
      CategoryType: 'نوع التصنيف',
      PublicNews: 'مقالات وأحداث عامة',
      CategoryNews: '     تصنيفات  الأخبار  ',
      ShortText: 'نص قصير ',
      ExamResult: 'نتائج الامتحانات',
      SetType: 'حدد النوع',
      AddQuranKaremCourse: 'حلقة ',
      LessonOrder: ' ترتيب الدرس  ',
      MeetingUrl: 'رابط الاجتماع',
      StudentLessons: 'دروس الطالب',
      StudnetLesson: 'دروس الطالب',
      AttachmentUrl: 'رابط الفيديو',
      LessonName: '   اسم الدرس',
      QuranKaremLevelType: 'النوع',
      ToAssignment: 'إلى واجب الدرس',
      FromAssignment: ' من واجب الدرس',
      Url: 'رابط',
      AddAttachment: 'ملفات مرفقة',
      IsOrphan: 'هل الطالب يتيم',
      ExpectedTotalPageSaving: 'عدد الصفحات التي يجب حفظها',
      ExpectedTotalPageReview: 'عدد الصفحات التي يجب مراجعتها',
      ExamPoint: 'علامة الامتحان',
      RequiredCount: 'عدد الاسئلة الاجبارية',
      SetDetail: 'تحديد المعلومات',
      SelectExam: ' حدد الامتحان',
      QuranKaremExamSetTeacherExam: 'تحديد الامتحانات والمدرسين للطلاب',
      TotalPage: 'عدد الصفحات',
      AlmaherMangement: 'إدارة برنامج الماهر',
      ManagingFliexibleSetting: 'إدارة الإعدادات المرنة',
      AddQuestion: 'اضافة سؤال',
      WrongPoint: 'علامة خاطئة',
      YouTubeUrl: 'رابط يوتيوب',
      QuranKaremCourseName: 'اسم حلقة القرآن الكريم',
      QuranKaremStageName: 'اسم المرحلة ',
      QuranKaremLevelName: 'اسم المستوى ',
      CourseExamName: 'اسم الدورة ',
      AppledCourseExam: 'المتقدمين على اختبار القاعدة التأسيسية',
      AppledQuranKaremExam: 'المتقدمين على اختبارات القرآن الكريم',
      ExamName: 'اسم الامتحان',
      CourseStudents: 'طلاب الدورة',
      SelectStudent: 'حدد طالب',
      SelectTeacher: 'حدد استاذ',
      Cv: 'السيرة الذاتية',
      ManagingBackPermissions: 'ادارة صلاحيات الباك ايند',
      ManagingFrontPermissions: 'ادارة صلاحيات الواجهة',
      SetLevel: 'اختر المستوى',
      Attachments: 'الملفات المرفقة',
      QuranCourseName: 'اسم الحلقة',
      AddStageDetails: 'اضافة تفاصيل المرحلة',
      StagesDetails: 'تفاصيل المرحلة',
      StudentsCount: 'عدد الطلاب',
      QuranKaremCourses: 'حلقات القرآن الكريم',
      QuranKaremCoursesMangments: 'ادارة الحلقات',
      TotalCourseCount: 'عدد حلقات الدورات',
      TotalLessonCount: 'عدد الدروس  ',
      TotalHomeWorkApplyedCount: 'عدد وظائف التي تقدم بها الطلاب',
      TeachersCount: 'عدد المدرسين',
      FamilyCount: 'عدد الأهالي',
      BranchiesCount: 'عدد المراكز',
      CourseName: 'اسم الدوره',
      QuranKaremExamName: 'اسم الامتحان',
      Point: 'العلامات',
      Appreciation: 'التقييم',
      ExamType: 'نوع الامتحان',
      QuestionPoint: 'علامة السؤال',
      Question: 'نص السؤال',
      TotalPageNumber: 'إجمالي صفحات',
      ExamSuperVisor: 'مشرف امتحاني',
      QuranKaremQuestions: 'اسئلة الاختبارات',
      CourseQuestions: 'اسئلة القاعدة التأسيسية',
      CourseExams: ' اختبارات القاعدة التأسيسية',
      QuranKaremExam: ' اختبارات القرآن الكريم',
      CreateQuranKaremExamQuestion: '   اختبار القرآن الكريم',
      CreateQuranKaremExam: '  الاختبار',
      Questions: 'ادارة الأسئلة',
      CourseExam: 'امتحانات الدروس',
      ApplyedCourseExam: 'المتقدمين على اختبارات القاعدة التأسيسية',
      ApplyedQuranKaremExam: 'المتقدمين على الاختبارات    ',
      Branch: 'فرع',
      Exams: 'ادراة الامتحانات',
      Exam: 'الاختبارات',
      Report: 'تقارير',
      Level: 'مستوى',
      New: 'جديد',
      HomeWork: 'الوظائف',
      QuranKarem: 'القرآن الكريم',
      Basic: 'عام',
      AllUsers: 'المستخدمين',
      EndTime: 'وقت الانتهاء',
      Homework: 'واجب منزلي',
      Clone: 'نسخ',
      InsertCsv: 'إدراج ملف CSV',
      TeacherName: 'اسم المعلم',
      StudentName: 'اسم الطالب',
      StudnetName: 'اسم الطالب',
      CourseTeachers: 'معلمي الدورة',
      AddLesson: 'إضافة درس',
      CourseStudent: 'طالب الدورة',
      QuranKaremStagee: 'مرحلة القرآن الكريم',
      CourseLevelMangments: 'إدارة مستوى الدورة',
      AddStage: 'إضافة مرحلة',
      FromPage: 'من الصفحة',
      AddLevelToCourse: 'إضافة مستوى للدورة',
      LevelStages: 'مراحل المستوى',
      QuranKaremLevel: 'مستوى القرآن الكريم',
      ToPage: 'إلى الصفحة',
      Order: 'الترتيب',
      SelectQuestion: 'اختر السؤال',
      Stage: 'المرحلة',
      IsHaveExam: 'هل هناك امتحان',
      StartTime: 'وقت البدء',
      FromPageSaving: 'من صفحة الحفظ',
      ToPageSaving: 'إلى صفحة الحفظ',
      FromPageReview: 'من صفحة المراجعة',
      ToPageReview: 'إلى صفحة المراجعة',
      ProgramsMangments: 'إدارة البرامج',
      ProgrameType: 'نوع البرنامج',
      LessonType: 'نوع الدرس',
      Content: 'المحتوى',
      FromPart: 'من الجزء',
      FromLesson: 'من الدرس',
      TotalPageLesson: 'اجمالي الدروس',
      ManagingLessonInfo: 'إدارة معلومات الدرس',
      LessonsInfo: 'معلومات الدروس',
      ManagingLessonType: 'إدارة نوع الدرس',
      ToPart: 'إلى الجزء',
      ToLesson: 'إلى الدرس',
      PlaceOfResidence: 'مكان الإقامة',
      CertificateAttachment: 'مرفق الشهادة',
      ArabicFullName: 'الاسم العربي الكامل',
      Nationality: 'الجنسية',
      FatherName: 'اسم الأب',
      MotherName: 'اسم الأم',
      UserIdNumber: 'رقم الهوية',
      PlaceOfResidenc: 'مكان الإقامة',
      CertificateName: 'اسم الشهادة',
      BestDayInThisYear: 'أفضل يوم في هذا العام',
      Birthday: 'تاريخ الميلاد',
      StudentCount: 'عدد الطلاب',
      News: 'أخبار التجمع ',
      BranchName: 'اسم المركز',
      TrainingName: 'اسم التدريب',
      StartDate: 'تاريخ البدء',
      EndDate: 'تاريخ الانتهاء',
      MaxStudentCount: 'الحد الأقصى لعدد الطلاب',
      Price: 'السعر',
      IsActive: 'نشط',
      CourseReport: 'حصاد الحلقة',
      Type: 'نوع الحلقة',
      AddStudent: 'إضافة طالب',
      AddTeacher: 'إضافة معلم',
      AddLevel: 'إضافة مستوى',
      TotalPageSavedCount: 'إجمالي عدد الصفحات المحفوظة',
      TotalPartSavedCount: 'إجمالي عدد الأجزاء المحفوظة',
      LessonMangments: 'إدارة الدروس',
      StagesMangments: 'إدارة المراحل',
      LevelsMangments: 'إدارة الفئات - المستويات ',
      CoursesMangments: 'إدارة الدورات',
      CoursMangments: 'إدارة الدورات',
      TeacherCount: 'عدد المعلمين',
      LogoImg: 'صورة الشعار',
      Courses: 'المناهج والدورات',
      AddressInMap: 'عنوان على الخريطة',
      Add: 'إضافة',
      ManagerUserId: ' مدير المركز',
      Lessons: 'الدروس',
      ManagingPositions: 'إدارة المناصب',
      Activities: 'أنشطة',
      ManagingCourses: 'إدارة الدورات',
      ManagingLesson: 'إدارة الدرس',
      Student: 'الطلاب',
      Family: 'الأسرة',
      Teacher: 'المعلمين',
      Branches: 'الفروع',
      Admins: 'المشرفين',
      Location: 'الموقع',
      CallUs: 'تواصل معنا',
      Send: 'ارسال',
      FollowUs: 'تابعنا',
      Newsletter: ' القوائم البريدية  ',
      YourEmailAddress: 'بريدك الالكتروني',
      ContactUs: 'تواصل معنا',
      ToGetNews: 'احصل على كل آخر أخبارنا',
      UsefulLink: 'روابط سريعة',
      VideoUrl: 'رابط الفيديو',
      Roles: 'الأدوار',
      Subscribe: 'اشترك',
      KeyWord: 'الكلمة الرئيسية',
      Visionforummah: ' تجمع من أجل أمة  ',
      ShortDesc: 'الوصف المختصر',
      Faq: 'أسئلة شائعة',
      BasicPages: 'الصفحات الأساسية',
      BasicPage: 'صفحة أساسية',
      MailingList: 'قائمة البريد',
      Contact: 'اتصل بنا',
      Activity: 'مشاركات',
      About: ' حولنا  ',
      ReadAll: ' المزيد',
      BadDayInThisYear: 'أسوأ يوم في هذا العام',
      BadDay: 'سيئ في هذا اليوم',
      BestDay: 'أفضل يوم',
      BestDiffValue: 'أفضل قيمة فرق',
      BadDiffValue: 'قيمة الفرق السيئة',
      BestTipValue: 'أفضل نصيحة',
      BadTipValue: 'نصيحة سيئة',
      BestBarValue: 'أفضل قيمة شريط',
      BadBarValue: 'قيمة شريط سيئة',
      Today: 'اليوم',
      Daily: 'يوميًا',
      Weekly: 'أسبوعيًا',
      Monthly: 'شهريًا',
      Yearly: 'سنويًا',
      AutoChooseSerialNumber: 'اختيار التسلسل تلقائيًا',
      SerailNumber: 'رقم التسلسل',
      MinimumQuantity: 'الحد الأدنى للكمية',
      Dashboard: 'لوحة التحكم',
      Quantity: 'الكمية',
      CrateionDate: 'تاريخ الإنشاء',
      GoToDetails: 'الانتقال إلى التفاصيل',
      QuantityInStock: 'الكمية في المخزن',
      Count: 'العدد',
      Tax: 'الضريبة',
      ProductName: 'اسم المنتج',
      Invoice: 'الفاتورة',
      AddProductToInvoice: 'إضافة منتج إلى الفاتورة',
      Used: 'مستخدم',
      NotUsed: 'غير مستخدم',
      SerialNumber: 'الرقم التسلسلي',
      Status: 'الحالة',
      CreationDate: 'تاريخ الإنشاء',
      ChooseFile: 'اختيار ملف',
      UploadFile: 'رفع الملف',
      DownloadSerialNumberFile: 'تنزيل ملف الأرقام التسلسلية',
      ProblemDetail: 'تفاصيل المشكلة',
      AddEditCommonMistakes: 'إضافة/تحرير الأخطاء الشائعة',
      Solution: 'الحل',
      Problem: 'المشكلة',
      MaterialType: 'نوع المواد',
      RemainedWarantyDays: 'أيام الضمان المتبقية',
      Catalog: 'الكتالوج',
      Done: 'تم',
      Required: 'مطلوب',
      NameLocale: 'الاسم باللغة المحلية',
      SellingPrice: 'سعر البيع',
      Cost: 'التكلفة',
      VendorInformation: 'معلومات البائع',
      AddNewVendors: 'إضافة بائع جديد',
      Vendors: 'البائعين',
      CommonMistakes: 'الأخطاء الشائعة',
      AddSerialNumbers: 'إضافة أرقام تسلسلية',
      InsertSerialNumber: 'إدراج الرقم التسلسلي',
      FullAddress: 'العنوان الكامل',
      Value: 'القيمة',
      ChannelName: 'اسم القناة',
      FullAdress: 'العنوان الكامل',
      Latitude: 'خط العرض',
      Longitude: 'خط الطول',
      State: 'الحالة',
      AddNewContact: 'إضافة اتصال جديد',
      AddNewAddress: 'إضافة عنوان جديد',
      CustomerInvoice: 'فاتورة العميل',
      Contacts: 'جهات الاتصال',
      City: 'المدينة',
      Address: 'العنوان',
      ACTIONS: 'الإجراءات',
      CustomerCategory: 'فئة العميل',
      FirstName: 'الاسم الأول',
      CustomerNumber: 'رقم العميل',
      EditCustomerInformation: 'تحرير معلومات العميل',
      AddNewCustomerInformation: 'إضافة معلومات عميل جديدة',
      LastName: 'اسم العائلة',
      AddressCount: 'عدد العناوين',
      ContactCount: 'عدد جهات الاتصال',
      AddNewCustomer: 'إضافة عميل جديد',
      PhoneNumber: 'رقم الهاتف',
      CustomerLastName: 'اسم العائلة للعميل',
      AddNewInvoice: 'إضافة فاتورة جديدة',
      SequenceNumber: 'رقم التسلسل',
      CustomerName: 'اسم العميل',
      TotalAmount: 'المبلغ الإجمالي',
      RemainingAmount: 'المبلغ المتبقي',
      Note: 'ملاحظة',
      NumberOfOrders: 'عدد الطلبات',
      AddProduct: 'إضافة منتج',
      Search: 'بحث',
      CustomerInformation: 'معلومات العميل',
      ProductNumber: 'رقم المنتج',
      NameAr: 'الاسم بالعربية',
      Description: 'الوصف',
      Warranty: 'الضمان',
      Barcode: 'الباركود',
      Notes: 'ملاحظات',
      Available: 'متاح',
      Unavailable: 'غير متاح',
      AddCatalog: 'إضافة كتالوج',
      AddImage: 'إضافة صورة',
      SearchbySerialNumber: 'البحث برقم التسلسل',
      User: 'المستخدم',
      Customers: 'العملاء',
      Chat: 'الدردشة',
      AddService: 'إضافة خدمة',
      SendNotification: 'إرسال إشعار',
      UsersMobile: 'أرقام الجوال للمستخدمين',
      AddSubSection: 'إضافة قسم فرعي',
      DiscountValue: 'قيمة الخصم',
      RegisteredDate: 'تاريخ التسجيل',
      FullName: '  الاسم الكامل بالاجنبي',
      Email: 'البريد الإلكتروني',
      DateBirth: 'تاريخ الميلاد',
      Phone: 'الهاتف',
      Gender: 'الجنس',
      Product: 'المنتج',
      UserName: 'اسم المستخدم',
      Rate: 'التقييم',
      FileType: 'نوع الملف',
      IsVisible: 'متاحة للتقديم عليها',
      comments: 'تعليقات',
      OrderCode: 'كود الطلب',
      Total: 'المجموع',
      Date: 'التاريخ',
      Section: 'القسم',
      SelectUser: 'اختيار المستخدم',
      SubSection: 'القسم الفرعي',
      Time: 'الوقت',
      Services: 'الخدمات',
      SubCategory: 'القسم الفرعي',
      Comments: 'التعليقات',
      Settings: 'الإعدادات',
      Reports: 'التقارير',
      Service: 'الخدمة',
      Img1: 'صورة 1',
      Img2: 'صورة 2',
      Img3: 'صورة 3',
      Img4: 'صورة 4',
      Category: 'الفئة',
      Name: 'الاسم',
      AddSubCategory: 'إضافة قسم فرعي',
      Image: 'الصورة',
      Sliders: 'الشرائح',
      Invoices: 'الفواتير',
      Actions: 'الإجراءات',
      Text: 'النص',
      Title: 'العنوان',
      Sections: 'الأقسام',
      Categories: 'الفئات',
      Offers: 'العروض',
      Teams: 'الفرق',
      Home: 'الصفحة الرئيسية',
      Clinic: 'العيادة',
      Orders: 'الطلبات',
      Products: 'المنتجات',
      Messages: 'الرسائل',
      Dates: 'التواريخ',
      Users: 'المستخدمون',
      AreYouSure: 'هل أنت متأكد',
      YouWillNotAble: 'لن تتمكن من استعادة هذا الملف الوهمي!',
      Warning: 'تحذير',
      YesDelete: 'نعم، احذفه!',
      NoKeep: 'لا، احتفظ به',
      Deleted: 'تم الحذف!',
      YourFileDeleted: 'تم حذف ملفك الوهمي!',
      Cancelled: 'تم الإلغاء',
      YourImaginarySafe: 'ملفك الوهمي آمن',
      SomethingWentWrong: 'حدث خطأ ما',
      RemovedSuccessfully: 'تمت إزالته بنجاح',
      UpdatedSuccessfully: 'تم التحديث بنجاح',
      AddedSuccessfully: 'تمت الإضافة بنجاح',
      DASHBOARD: 'لوحة التحكم',
      Cancel: 'إلغاء',
      Save: 'حفظ',
      Back: 'رجوع',
      Reset: 'إعادة تعيين',
      Edit: 'تحرير',
      Create: 'إنشاء',
      Correct: 'صحيح',
      IsRequired: 'مطلوب',
      ButThisAlreadyAdded: 'لكن هذا تمت إضافته بالفعل',
      IsDeleting: 'جاري الحذف...',
      Delete: 'حذف',
      DeletePermanently: 'هل أنت متأكد من حذف هذا السجل نهائيًا؟',
      AddNew: 'إضافة جديد'
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don\'t have an account?',
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username'
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields'
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    }
  }
};
